import styled from 'styled-components';

import StyledInput from '../../../../../components/Input/StyledInput';

const StyledPhoneInput = styled(StyledInput)`
  ${({ theme, $showInputIcon }) => {
    return `
        ${`padding-left: ${(theme.inputSpacing?.paddingLeft ?? 0) + ($showInputIcon ? 48 : 0)
      }px;`}
  `;
  }}
`;

export default StyledPhoneInput;
